import { useState, useEffect, useRef } from "react";
import { apiContext } from "../../../context/api-v1/api";
import store from "../../../reducers/store";
import PageNum from "./pageNum";
import ArticleListRender from "./articleList";
import { checkMobile } from "../../../utils/utils";
import { Page404 } from "../../../components/PageCommon";
import { apiDict } from "../../../context/api-v1/api";
import { getQueryStringArgs } from "../../../utils/utils";

import {
  Container,
  Card,
  CardMedia,
  CardContent,
  Avatar,
  Typography,
  Box,
  colors,
} from "@mui/material";

function buildPageUrl(pageNum, searchValue = "") {
  if (searchValue) {
    return `${apiDict.article}?page=${pageNum}&search=${searchValue}`;
  }
  return `${apiDict.article}?page=${pageNum}`;
}

function getRequestUrl(url) {
  if (url.substr(0, 4) === "http") {
    return url;
  }
  return apiDict.base + url;
}

function getCacheKey(pageNum, searchValue = "") {
  return `${pageNum}::${searchValue || ""}`;
}

export default function ArticleLayout() {
  let query = getQueryStringArgs();
  const initialQueryRef = useRef({
    page: query.page ? parseInt(query.page) : 1,
    search: query.search ? query.search : "",
  });
  const oldPage = initialQueryRef.current.page;
  const oldSearch = initialQueryRef.current.search;

  const [blogDatas, setBlogDatas] = useState();
  const [currentPageUrl, setCurrentPageUrl] = useState();
  const [searchContent, setSearchContent] = useState(oldSearch);
  const pageRef = useRef({ pageNum: oldPage, prevSearchContent: oldSearch });
  const pageCacheRef = useRef({});
  // const sectionRef = useRef(null); // 翻页上滑锚点定位

  const is_phone = checkMobile();

  let nextPage, previousPage, blogCount, blogList;
  if (blogDatas) {
    nextPage = blogDatas.next;
    previousPage = blogDatas.previous;
    blogCount = blogDatas.count;
    blogList = blogDatas.results;
    apiDict["origin"] = blogDatas.origin;
  }

  let scrollMulti = 0.3;
  if (is_phone) {
    scrollMulti = 0.08;
  }

  useEffect(() => {
    function setPageData(data, pageNum, searchValue) {
      const cacheKey = getCacheKey(pageNum, searchValue);
      pageCacheRef.current[cacheKey] = data;
      setBlogDatas(data);
    }

    if (
      typeof searchContent !== "undefined" &&
      searchContent !== "" &&
      searchContent !== pageRef.current.prevSearchContent
    ) {
      pageRef.current.prevSearchContent = searchContent;
      pageRef.current.pageNum = 1;
      window.history.pushState({}, "", `?page=1&search=${searchContent}`);
      const cacheKey = getCacheKey(1, searchContent);
      if (pageCacheRef.current[cacheKey]) {
        setBlogDatas(pageCacheRef.current[cacheKey]);
      } else {
        apiContext(
          buildPageUrl(1, searchContent),
          "GET",
          (data) => setPageData(data, 1, searchContent)
        );
      }
    } else {
      const targetPage = currentPageUrl ? pageRef.current.pageNum : oldPage || 1;
      const targetSearch = currentPageUrl ? searchContent : oldSearch;
      const cacheKey = getCacheKey(targetPage, targetSearch);

      if (pageCacheRef.current[cacheKey]) {
        setBlogDatas(pageCacheRef.current[cacheKey]);
        return;
      }

      if (currentPageUrl) {
        apiContext(
          currentPageUrl,
          "GET",
          (data) => setPageData(data, targetPage, targetSearch)
        );
      } else {
        if (oldPage) {
          apiContext(
            buildPageUrl(oldPage, oldSearch),
            "GET",
            (data) => setPageData(data, oldPage, oldSearch)
          );
        } else {
          apiContext(apiDict.article, "GET", (data) => setPageData(data, 1, ""));
        }
      }
    }
  }, [currentPageUrl, searchContent]);

  useEffect(() => {
    if (!blogDatas || !blogDatas.allPage) {
      return;
    }

    const nextPageNum = pageRef.current.pageNum + 1;
    if (!nextPageNum || nextPageNum > blogDatas.allPage) {
      return;
    }

    const cacheKey = getCacheKey(nextPageNum, searchContent);
    if (pageCacheRef.current[cacheKey]) {
      return;
    }

    const targetUrl = buildPageUrl(nextPageNum, searchContent);
    fetch(getRequestUrl(targetUrl), {
      method: "GET",
      mode: "cors",
      credentials: "include",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          return null;
        }
        return resp.json().catch(() => null);
      })
      .then((data) => {
        if (data) {
          pageCacheRef.current[cacheKey] = data;
        }
      })
      .catch(() => null);
  }, [blogDatas, searchContent]);

  useEffect(() => {
    // let oldData = store.getState().customization.searchArticle;
    const unsubscribe = store.subscribe(() => {
      const data = store.getState().customization.searchArticle;
      setSearchContent(data);
      // if (data !== oldData) {
      //   setSearchContent(data);
      //   oldData = data;
      // }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  // function handleClick(e, step) {
  //   e.preventDefault();

  //   if (step === 1) {
  //     if (nextPage) {
  //       setCurrentPageUrl(nextPage);
  //       pageRef.current.pageNum += 1;
  //     }
  //   } else {
  //     if (previousPage) {
  //       setCurrentPageUrl(previousPage);
  //       pageRef.current.pageNum -= 1;
  //     }
  //   }
  // }

  function handlePageClick(e, v) {
    if (searchContent) {
      setCurrentPageUrl(buildPageUrl(v, searchContent));
      window.history.pushState({}, "", `?page=${v}&search=${searchContent}`);
    } else {
      setCurrentPageUrl(buildPageUrl(v));
      window.history.pushState({}, "", `?page=${v}`);
    }

    pageRef.current.pageNum = v;
    // sectionRef.current.scrollIntoView();
    window.scrollTo(0, window.innerHeight * scrollMulti);
  }
  return blogCount !== 0 ? (
    <>
      <ArticleListRender
        blogList={blogList}
        page={pageRef.current.pageNum}
        search={searchContent}
      />
      <PageNum
        blogDatas={blogDatas}
        handlePageClick={handlePageClick}
        pageRef={pageRef}
      />
    </>
  ) : (
    <Page404 />
  );
}
